import { getPremiumContext } from "@memorang/helpers/bundle";
import type { ExamDetails } from "@memorang/types";
import { getShowStudyPackViews } from "./exams";
import { isWeb } from "./platform";

const physicianRoles = [
	"orthopaedic_surgeon",
	"physician_associate",
	"resident",
	"fellow",
];
export const getDisplayName = (
	role?: string,
	firstName?: string,
	lastName?: string,
) => {
	const isPhysician = role && physicianRoles.includes(role);
	return isPhysician ? `Dr. ${lastName || ""}` : firstName || "";
};

export const getPurchasedExams = (examsList: ExamDetails[]) => {
	const purchasedExams = examsList?.filter(({ exam: { bundles } }) => {
		return bundles.find((item) => {
			const { hasAccess } = getPremiumContext(item.metadata);
			return hasAccess;
		});
	});
	return purchasedExams;
};

export const getPurchasedProducts = (examsList: ExamDetails[]) => {
	const purchasedExams = getPurchasedExams(examsList);

	const purchasedProducts = purchasedExams?.flatMap(({ exam }) =>
		exam.bundles.filter((item) => {
			return (
				getPremiumContext(item.metadata).hasAccess &&
				(item.bundle.bundleType === "PRACTICE_TEST"
					? isWeb
					: getShowStudyPackViews(exam.studyPackCollection?.[0]))
			);
		}),
	);
	return purchasedProducts;
};
